import { render, staticRenderFns } from "./PurchaseImport.vue?vue&type=template&id=47e701d5&scoped=true&"
import script from "./PurchaseImport.vue?vue&type=script&lang=js&"
export * from "./PurchaseImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e701d5",
  null
  
)

export default component.exports